import axios from "axios";
import dayjs from "dayjs";
import Resizer from "react-image-file-resizer";

export const parsePhone = (x) => {
  if (!x) return "-";
  return x.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
};

export const parseMoney = (x) => {
  if (x === 0) return "0";
  if (!x) return "-";
  return parseInt(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const driverSanjaeFee = (driverPrice) => {
  if (driverPrice === 0 || !driverPrice) return 0;
  return Math.floor((driverPrice * 0.501 * 0.0088) / 10) * 10;
};

export const quickPayFee = (driverPrice) => {
  if (driverPrice === 0 || !driverPrice) return 0;
  return Number(driverPrice) * 1.1 * 0.015;
};

export const finalDriverPrice = (driverPrice, isSanjaeExcluded = false, isQuickPay = false) => {
  if (driverPrice === 0 || !driverPrice) return 0;
  if (isQuickPay) {
    if (isSanjaeExcluded) {
      return parseInt(driverPrice * 1.1 - quickPayFee(driverPrice));
    }
    if (!isSanjaeExcluded) {
      return parseInt(driverPrice * 1.1 - driverSanjaeFee(driverPrice) - quickPayFee(driverPrice));
    }
  }
  if (isSanjaeExcluded) return parseInt(driverPrice * 1.1);
  return parseInt(driverPrice * 1.1 - driverSanjaeFee(driverPrice));
};

export const parseBusinessNumber = (x) => {
  if (!x) return "-";
  const digits = x.replace(/[^0-9]/g, "");
  if (digits.length !== 10) return x;
  return digits.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
};

export const trimPhoneNumber = (x) => {
  if (!x) return "";
  return x.replace(/[\s-]/g, "");
};

export const getGeoListFromAddress = async (query) => {
  const HEADERS = {
    Authorization: "KakaoAK f5c69e26b945f67fced2f5394b19eb2c",
    "Content-Type": "application/json; charset=utf-8",
  };

  const ff = await fetch(`https://dapi.kakao.com/v2/local/search/address?query=${query}`, {
    method: "GET",
    headers: HEADERS,
  });

  const result = await ff.json();
  const docs = result?.documents;

  if (docs.length === 0) return [];

  return docs.map((doc) => {
    const { address, road_address, address_type } = doc;
    return {
      lat: parseFloat(doc?.address?.y),
      lng: parseFloat(doc?.address?.x),
      address: address_type === "ROAD_ADDR" ? road_address?.address_name : address?.address_name,
      name: address_type === "ROAD_ADDR" ? road_address?.address_name : address?.address_name,
      phone: "",
    };
  });
};

export const getGeoCodeFromAddress = async (query) => {
  const HEADERS = {
    Authorization: "KakaoAK f5c69e26b945f67fced2f5394b19eb2c",
    "Content-Type": "application/json; charset=utf-8",
  };

  const ff = await fetch(`https://dapi.kakao.com/v2/local/search/address?query=${query}`, {
    method: "GET",
    headers: HEADERS,
  });

  const result = await ff.json();
  const docs = result?.documents;

  if (docs.length !== 0) {
    const { address, road_address, address_type } = docs[0];
    return {
      lat: parseFloat(docs[0]?.address?.y),
      lng: parseFloat(docs[0]?.address?.x),
      address: address_type === "ROAD_ADDR" ? road_address?.address_name : address?.address_name,
    };
  } else {
    return {
      lat: 0,
      lng: 0,
      address: "",
    };
  }
};

export const getOldAddressFromNewAddress = async (query) => {
  const { data } = await axios({
    url: "https://dapi.kakao.com/v2/local/search/address",
    method: "GET",
    params: { query },
    headers: {
      Authorization: "KakaoAK f5c69e26b945f67fced2f5394b19eb2c",
    },
  });

  const address = data?.documents?.[0]?.address;
  if (!address) return { d1: "", d2: "", d3: "", d3h: "", full: "" };

  return {
    d1: address.region_1depth_name,
    d2: address.region_2depth_name,
    d3: address.region_3depth_name, // 법정동 (ex. 성내동)
    d3h: address.region_3depth_h_name, // 행정동 (ex. 성내2동)
    full: address.address_name,
  };
};

export const getGeoListFromLocation = async (query) => {
  const HEADERS = {
    Authorization: "KakaoAK f5c69e26b945f67fced2f5394b19eb2c",
    "Content-Type": "application/json; charset=utf-8",
  };

  const fff = await fetch(`https://dapi.kakao.com/v2/local/search/keyword?query=${query}`, {
    method: "GET",
    headers: HEADERS,
  });

  const res = await fff.json();
  const resDocs = res?.documents;

  if (resDocs.length === 0) return [];

  return resDocs.map((doc) => {
    return {
      lat: parseFloat(doc?.y),
      lng: parseFloat(doc?.x),
      address: doc?.road_address_name || doc?.address_name,
      name: doc?.place_name,
      phone: doc?.phone || "",
    };
  });
};

export const resizeFile = (file) => {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1920,
      1920,
      "JPEG",
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
    );
  });
};

export const calcPayReserveDate = (dateString) => {
  const originalDate = dayjs(dateString);
  const weekdayExcel = originalDate.day() === 0 ? 7 : originalDate.day();
  return originalDate.add(30 - weekdayExcel, "day").format("YYYY-MM-DD");
};
